///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rx_import_items = abcsetup.rx_import_items || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rx_import_items.index = {
    init: function() {
        abcsetup.setTitle('Imported Consumer Items');

        // Delete button clicked
        $(document).on('click', '#rxitemimportitem-table .btn-delete', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Delete Item', 'Are you sure you want to delete this record?', function (resp) {
                if (resp) {
                    abcsetup.rx_import_items.index.delete(_this.data('id'));
                }
            });
        });

        /**
         *
         */
        setInterval(function() {
            $("#rxitemimportitem-table > tbody > tr div.status").each(function() {
                var status_element = $(this);
                var id = status_element.data("id");
                var status = status_element.data("status");

                var rows_imported_element = $(".rows_imported");
                var id = rows_imported_element.data("id");

                if (!id || !status) {
                    console.log('poll_import_item: invalid id/status');
                    return;
                }

                if (status != 'error' && status != 'success') {
                    axios.get("/api/rx_import_items/record/"+id).then(result => {
                        console.log("/api/rx_import_items/record: result"+JSON.stringify(result,{},4));

                        if (result.data.status == 'error') {
                            status_element.toggleClass("alert-info alert-danger");
                        }
                        else if (result.data.status == 'success') {
                            status_element.toggleClass("alert-info alert-success");
                        }

                        status_element.data("status",result.data.status);
                        status_element.data("rows",result.data.data_rows_imported);

                        if (result.data.status == 'error' || result.data.status == 'success') {
                            status_element.html(result.data.status_name);

                            if (parseInt(result.data.data_rows_imported) > 0) {
                                rows_imported_element.html('<a href="rx_import_items/load_data/'+id+' class="btn btn-sm btn-primary" title="Click to view imported file data records and create new items from these records">'+result.data.data_rows_imported+'</a>');
                            } else {
                                rows_imported_element.html(result.data.data_rows_imported);
                            }
                        } else {
                            status_element.find(".status_text").html(result.data.status_name);
                        }
                    });
                }
            });
        }, 2000);
    },

    /**
     *
     * @param {*} id
     */
    delete: function(id) {
        axios.delete('/rx_import_items/' + id).then(response => {
            window.location.reload();
        });
    },
}
